import { Grid2, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { UserTypeEnum } from "../../_common/enum/userType.enum";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";
import EnumSelect from "../../_components/autocomplete/enum.select";
import { StandardButton } from "../../_components/button/primary.button";
import { StandardTextValidator } from "../../_components/textValidator/standardTextValidator";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { formService } from "../../_services/form.service";
import { formTemplateService } from "../../_services/formTemplate.service";
import { API_URL } from "../../_config/config.const";
import { tokenService } from "../../_services/token.service";

export function FormTemplateManage(params: {
    emitOnSave: (id?: number) => void,
    emitOnClose: () => void,
}) {

    const { formTemplateId } = useParams<{ formTemplateId: string }>();

    const [data, setData] = useState(getResetData);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (formTemplateId) fetchData();
        else setData(getResetData);
    }, [formTemplateId]);

    function getResetData(): any {
        return {};
    }

    function fetchData() {
        setLoading(true);
        return formTemplateService
            .get(+(formTemplateId || 0))
            .then(
                (json) => {
                    if (json) {
                        setData(json);
                    }
                    else setData(getResetData);
                }
            )
            .finally(() => setLoading(false));
    }

    function disable() {
        setSaving(true);
        return formTemplateService
            .disable(+(formTemplateId || 0))
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.emitOnClose();
                },
                handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    // function submitForm() {
    //     setSaving(true);
    //     return formTemplateService
    //         .submitForm(+(formTemplateId || 0))
    //         .then(
    //             (id: number) => {
    //                 toastr.success("Form template submitted successfully");
    //                 params.emitOnSave(id);
    //             },
    //             handleErrorResponse
    //         )
    //         .finally(() => setSaving(false));
    // }


    function submitForm(e: any) {
        e.preventDefault();
        setSaving(true);

        var fileInputField = document.getElementById("file")

        const formData = new FormData();
        formData.append("id", (data.id || 0).toString());
        formData.append("file", (fileInputField as any)?.files[0]);
        formData.append("formTemplateTypeId", (data.formTemplateTypeId || 0).toString());
        formData.append("name", (data.name || "").toString());
        const userTypeId = data.userTypeId;
        formData.append(
            "userTypeId",
            userTypeId === null || userTypeId === undefined || userTypeId === ""
                ? ""
                : String(userTypeId),
        );

        return formTemplateService[(data.id || 0) > 0 ? "put" : "post"](formData)
            .then(
                (json) => {
                    toastr.success("Form template submitted successfully");
                    params.emitOnSave(data.id);
                }, handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    function createSample() {
        setSaving(true);
        return formService
            .createSample(+(formTemplateId || 0))
            .then(
                (id: number) => {
                    toastr.success("Form created successfully");
                },
                handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    function duplicateForm() {
        setSaving(true);
        return formTemplateService
            .duplicateForm(+(formTemplateId || 0))
            .then(
                (id: number) => {
                    toastr.success("Form template duplicated successfully");
                    params.emitOnSave(id);
                },
                handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }))
    };

    function onError(event: any) {
        toastr.error("Please verify that all fields have correct input");
    }

    return (
        <>
            <ValidatorForm onError={onError} onSubmit={submitForm} noValidate>

                <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12 }}>
                        <StandardTextValidator
                            label="Name"
                            value={data.name}
                            name="name"
                            required
                            fullWidth
                            disabled={data.formStatusId !== FormStatusEnum.New && data.formStatusId !== FormStatusEnum.InProcess && data.id > 0}
                            validators={['required']}
                            errorMessages={['This field is required']}
                            onChange={handleChange}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <EnumSelect
                            enumObject={FormTemplateTypeEnum}
                            label="Form Template Type"
                            name="formTemplateTypeId"
                            value={data.formTemplateTypeId}
                            disabled={data.formStatusId !== FormStatusEnum.New && data.formStatusId !== FormStatusEnum.InProcess && data.id > 0}
                            onChange={handleChange}
                            required
                        />

                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <EnumSelect
                            enumObject={UserTypeEnum}
                            label="User type"
                            name="userTypeId"
                            value={data.userTypeId ?? null}
                            onChange={handleChange}
                            includeEmptyOption
                            emptyOptionLabel="All user types"
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 6 }}>
                        <TextField
                            label="Form Template File"
                            type="file"
                            id="file"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 6 }}>
                        {(!!data.id && !!data.fileUploadId) &&
                            <StandardButton icon={"download"} variant="primary" type="button" onClick={() => {
                                tokenService.GetReportToken().then((_token) => {
                                    window.open(API_URL + "/fileUpload/GetFile/?token=" + _token + "&fileUploadId=" + data.fileUploadId);
                                });
                            }}>Download Template File</StandardButton>
                        }
                    </Grid2>

                    <Grid2 size={{ xs: (!data.id ? 12 : 6) }}>
                        <StandardButton
                            type="submit"
                            icon="save"
                            loading={loading}
                            saving={saving}>
                            Save
                        </StandardButton>
                    </Grid2>

                    {(data.id > 0) &&
                        <Grid2 size={{ xs: (!data.id ? 12 : 6) }}>
                            <StandardButton
                                type="button"
                                variant="error"
                                icon="clear"
                                loading={loading}
                                saving={saving}
                                onClick={disable}>
                                Disable
                            </StandardButton>
                        </Grid2>
                    }

                    {/* <br />
                    <br />

                    {(data.formStatusId === FormStatusEnum.New || data.formStatusId === FormStatusEnum.InProcess) &&
                        <Grid2 size={{ xs: 12 }}>
                            <StandardButton
                                icon="upload"
                                type="submit"
                                loading={loading}
                                saving={saving}
                                onClick={submitForm}>

                                <Icon>upload</Icon> Approve Form Template and push LIVE
                            </StandardButton>
                        </Grid2>
                    } */}

                    <br />
                    <br />

                    <Grid2 size={{ xs: 12 }}>
                        <StandardButton
                            icon="check"
                            type="button"
                            loading={loading}
                            saving={saving}
                            variant="info"
                            onClick={createSample}>

                            Create Sample
                        </StandardButton>
                    </Grid2>

                </Grid2>

            </ValidatorForm >

        </>
    );
}